import React from "react";

const FormControl = React.forwardRef(
  ({ className = "", type = "text", ...other }, ref) => {
    return (
      <input
        ref={ref}
        className={`${className} h-8 inline-block leading-5 text-sm font-light form-control`}
        type={type}
        {...other}
      />
    );
  }
);

export default FormControl;
